module.exports = __webpack_public_path__ + "static/EventTech-8293434f3b4609877f8cdb28d9a3570f.jpg";